import React from 'react';
import { render } from 'react-dom';
import { connect } from 'react-redux';
import { appEnv } from '../constants/appEnv';

export const searchPageName = 'SearchResults.aspx';
export const searchPagingParams = '&sc=BM&fi=1&fr=1';

class PrinterSearchBox extends React.Component {
    constructor() {
        super();
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            keyword: ''
        };
    }
    handleChange(event) {
        this.setState({ keyword: event.target.value });
    }
    handleSubmit(event) {
        if (this.state.keyword) {
            const searchCategoryScopeProp = "Ink and Toner Search Category Scope";
            let searchCategoryScope = this.props.configPropValues[searchCategoryScopeProp] || "C000765";

            location.href = searchPageName + '?Keyword=' + this.state.keyword + '&Category=' + searchCategoryScope + searchPagingParams;
        }
        event.preventDefault();
    }
    render() {
        const searchExampleTextProp = "Ink and Toner Search Example Text";
        let searchExampleText = this.props.configPropValues[searchExampleTextProp];
        return (
            <div className="row search-printer">
                <div className="col-md-12">
                    <h3 className="dynamic-vertical-header normaltext">Search by Printer or Cartridge</h3>
                </div>
                <div className="col-md-12">
                    <form onSubmit={this.handleSubmit}>
                        <label htmlFor="inkTonerFinderSearch" className="sr-only">Search by Printer or Cartridge</label>
                        <input type="text"
                            id="inkTonerFinderSearch"
                            name="inkTonerFinderSearch"
                            placeholder={searchExampleText}
                            value={this.state.keywork}
                            onChange={this.handleChange} />
                        <button type="submit" className="btn-search">
                            <img src={appEnv.baseImgUrl + '/blue-search-btn.png'} alt="Click to Search"/>
                        </button>
                    </form>
                </div> 
            </div>
        );
    }
}
function mapStateToProps(state, ownProps) {
    return {
        configPropValues: state.configPropValues
    };
}
export default connect(mapStateToProps)(PrinterSearchBox);  